import React, { useContext } from "react";
import colorSharp from "../assets/img/color-sharp.png"

const Experience = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="experience">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Experience</h2>
                        <p>I possess over 3 years of expertise in C# and the .NET Framework, having successfully completed more than 12 projects. Additionally, I have accrued 2+ years of valuable experience working with these technologies in a professional setting, delivering effective solutions and contributing to the success of various projects.</p>
                      
                        <div className="experience" id='experience'>
      <div className="achievement">
        {/* darkMode */}
       <div className="circle">3+</div>
        <span>years </span>
      <span style={{ color: '#00ff00' }}>Experience</span>
     </div>
       <div className="achievement">
     <div className="circle">12+</div>
      <span>completed </span>
         <span style={{ color: '#00ff00' }}>Projects</span>
       </div>
       <div className="achievement">
         <div className="circle">2+</div>
         <span>companies </span>
         <span style={{ color: '#00ff00' }}>Work</span>
       </div>
   </div>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
  // return (
  //   <div className="experience" id='experience'>
  //     <div className="achievement">
  //       {/* darkMode */}
  //       <div className="circle">3+</div>
  //       <span>years </span>
  //       <span>Experience</span>
  //     </div>
  //     <div className="achievement">
  //       <div className="circle">10+</div>
  //       <span>completed </span>
  //       <span>Projects</span>
  //     </div>
  //     <div className="achievement">
  //       <div className="circle">2+</div>
  //       <span>companies </span>
  //       <span>Work</span>
  //     </div>
  //   </div>
  // );
};

export default Experience;